(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('shift', {
                parent: 'entity',
                url: '/shift',
                data: {
                    authorities: [],
                    pageTitle: 'Shifts'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/shift/list/shift.html',
                        controller: 'ShiftController',
                        controllerAs: 'vm'
                    },
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_SHIFT];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_SHIFT, access);
                }]
            });
    }
})();
